class Workable {
    constructor() {
        this.parseInfo = this.parseInfo.bind(this);
        this.prettifyInfo = this.prettifyInfo.bind(this);
        this.determineTitle = this.determineTitle.bind(this);
        this.waitForElement = this.waitForElement.bind(this);
        this.init = this.init.bind(this);

        this.init();
    }

    waitForElement(query, timeout = 10000) {
        return new Promise((resolve, reject) => {
            const startTime = Date.now();
            const tryQuery = () => {
                const elem = document.querySelector(query);
                if (elem) resolve(elem); // Found the element
                else if (Date.now() - startTime > timeout) resolve(null); // Give up eventually
                else setTimeout(tryQuery, 10); // check again every 10ms
            };
            tryQuery(); // Initial check
        });
    }

    // Will determine the title of the info based on the classname.
    determineTitle(info) {
        let title;

        if (info.classList.contains('whr-dept')) title = 'team';
        if (info.classList.contains('whr-location')) title = 'location';

        return title;
    }

    // Will remove the span and put the text into a div
    prettifyInfo(info) {
        const span = info.querySelector('span');
        if (span) span.remove();

        const div = document.createElement('div');
        div.insertAdjacentHTML('beforeend', `<span>${info.textContent}</span>`);

        const title = this.determineTitle(info);
        div.insertAdjacentHTML('afterbegin', `<span class="whr-title">${title}</span>`);

        return div;
    }

    makeApplyButton(container, link) {
        if (!link || !container) return;

        const a = document.createElement('a');
        a.classList.add('workable-apply-button');
        a.insertAdjacentHTML(
            'beforeend',
            `
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path d="M304 24c0 13.3 10.7 24 24 24l102.1 0L207 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l223-223L464 184c0 13.3 10.7 24 24 24s24-10.7 24-24l0-160c0-13.3-10.7-24-24-24L328 0c-13.3 0-24 10.7-24 24zM72 32C32.2 32 0 64.2 0 104L0 440c0 39.8 32.2 72 72 72l336 0c39.8 0 72-32.2 72-72l0-128c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 128c0 13.3-10.7 24-24 24L72 464c-13.3 0-24-10.7-24-24l0-336c0-13.3 10.7-24 24-24l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 32z"/></svg>
                <span>Apply</span>
        `
        );

        a.target = '_blank';
        a.href = link;
        a.setAttribute('alt', 'Apply for job, opens in new tab');
        container.insertAdjacentElement('beforeend', a);
    }

    // Will loop through all the info and put them into individual divs
    parseInfo(el) {
        const infoList = el.querySelectorAll('.whr-info li');

        infoList.forEach((info, index) => {
            if (info.classList.contains('whr-date')) info.remove();
            const prettyInfo = this.prettifyInfo(info);
            const anchor = info.parentElement;
            if (!anchor) return;

            anchor.insertAdjacentElement('beforebegin', prettyInfo);

            if (index == infoList.length) {
                anchor.remove();
            }
        });
    }

    deleteOldInfo(career) {
        const info = career.querySelector('.whr-info');
        if (info) info.remove();
    }

    addTitleToh3(career) {
        const h3 = career.querySelector('h3');
        if (!h3) return;

        const div = document.createElement('div');
        div.insertAdjacentHTML('beforeend', `<h3>${h3.textContent}</h3>`);
        div.insertAdjacentHTML('afterbegin', `<span class="whr-title">job title</span>`);

        h3.insertAdjacentElement('beforebegin', div);
        h3.remove();
    }

    fillInMissingInfo(career) {
        const info = career.querySelector('.whr-info');
        if (!info) return;

        const defaultTeamEl = document.querySelector('.js-workable-default-team');
        if (!defaultTeamEl) return;

        const defaultTeam = defaultTeamEl.dataset.team;
        if (!defaultTeam) return;

        if (!info.querySelector('.whr-dept')) {
            info.insertAdjacentHTML('afterbegin', `<li class="whr-dept">${defaultTeam}</li>`);
        }

        if (!info.querySelector('.whr-location')) {
            info.querySelector('.whr-dept').insertAdjacentHTML('afterend', `<li class="whr-location"></li>`);
        }
    }

    //Will loop through all the careers
    splitCareers() {
        const careers = document.querySelectorAll('.whr-item');
        careers.forEach(career => {
            let link;
            if (career.querySelector('h3 a')) {
                link = career.querySelector('h3 a').getAttribute('href');
            } else {
                link = '#';
            }
            this.fillInMissingInfo(career);
            this.parseInfo(career);
            this.deleteOldInfo(career);
            this.addTitleToh3(career);
            this.makeApplyButton(career, link);
        });
    }

    async init() {
        const el = await this.waitForElement('.whr-item');
        if (!el) return;

        this.splitCareers();
    }
}

new Workable();
